/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_S3_Upload_FailedInputs */

const en_api_error_s3_upload_failed = /** @type {(inputs: Api_Error_S3_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S3 upload failed.`)
};

const pt_br2_api_error_s3_upload_failed = /** @type {(inputs: Api_Error_S3_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no upload para o S3.`)
};

/**
* | output |
* | --- |
* | "S3 upload failed." |
*
* @param {Api_Error_S3_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_s3_upload_failed = /** @type {((inputs?: Api_Error_S3_Upload_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_S3_Upload_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_s3_upload_failed(inputs)
	return pt_br2_api_error_s3_upload_failed(inputs)
});